export default {
    menu: {
        dashboard: 'dashboard',
        auctions: 'aste',
        auction_calendars: 'calendario',
        selection_sites: 'centri selezione',
        subscribers: 'accreditati'
    },
    auction: {
        auctions: 'Aste',
        open: 'In corso',
        published: 'Pubblicate',
        closed: 'Chiuse',
        redistributing: 'Redistribuzione',
        not_available: 'Nessuna asta disponibile.',
        will_close_at: 'L\'Asta chiuderà il',
        redistribution_will_close_at: 'La redistribuzione chiuderà il',
        closed_at: 'L\'Asta si è chiusa il',
        will_open_at: 'L\'Asta si aprirà il',
        opening_date: 'Data apertura Asta',
        closing_date: 'Data chiusura Asta',
        at_time: 'alle ore',
        opening: 'Apertura',
        closing: 'Chiusura',
        you_are_winning: 'Quantità best',
        you_can_bid_on: 'Quantità residua',
        product_category: 'Categoria Prodotto',
        total_quantity: 'Quantità totale',
        min_quantity: 'QMGC',
        redistributable_quantity: 'Quantità redistribuibile',
        details: 'Dettagli',
        lot: 'Lotto',
        lot_count: 'Totale lotti',
        lot_list: 'Elenco Lotti',
        waste_code: 'Codice Rifiuto',
        start_price: 'Prezzo Iniziale',
        effective_price: 'Prezzo Attuale',
        availability: 'Disponibilità',
        expiration: 'Scadenza',
        remaining: 'Rimanente',
        bid: 'Rilancia',
        bid_count: 'Rilanci',
        as_group: 'gruppo',
        redistribution: 'Redistribuzione lotti',
        no_preemptions_available: 'Non hai nessun lotto disponibile per la redistribuzione',
        choose_preemptions: 'Scegli i lotti per i quali vuoi attivare la redistribuzione:',
        winning: 'Vincente',
    },
    calendar: {
        calendar: 'Calendario Aste'
    },
    lot: {
        choose_bid: 'Seleziona un rilancio per il lotto',
        you_are_bidding: 'Stai per effettuare {0} rilanci.',
        you_are_preempting: 'Stai per confermare il lotto',
        value: 'Valore rilancio:',
        first_bid: 'Stai facendo la prima offerta per il lotto',
        relaunch_with_successful: 'Rilancio inviato con successo',
        relaunch_error: 'Rilancio in errore',
        added_to_bookmark: 'Lotto {lot} aggiunto ai preferiti',
        removed_from_bookmark: 'Lotto {lot} rimosso dai preferiti',
        you_won: 'Ti sei aggiudicato il lotto',
        closed: 'Lotto chiuso',
        you_are_winning: 'Ti stai aggiudicando il lotto',
        outbid: 'Ti hanno appena superato',
        remaining_time: 'Mancano',
        redistributed_with_success: 'Redistribuzione avvenuta con successo',
        preempt: 'Conferma',
        preempted: 'Redistribuito',
        premption_not_available: 'N/A',
        assigned_quantity: 'Quantità assegnata',
        standard: 'Standard',
        redistribute: 'Redistribuibili',
        attributes: {
            tipoPagamento: {
                name: 'Tipo di Pagamento',
                values: {
                    "bonifico45ggDF": "Bonifico Bancario 45 giorni D.F.",
                    "bonifico30ggDF": "Bonifico Bancario 30 giorni D.F.",
                    "bonifico60ggDF": "Bonifico Bancario 60 giorni D.F.",
                    "anticipato": "Pagamento anticipato",
                    "fideiussione": "Fideiussione bancaria",
                    "riba30ggDF": "Ricevuta bancaria 30 giorni D.F.",
                    "riba45ggDF": "Ricevuta bancaria 45 giorni D.F.",
                    "riba60ggDF": "Ricevuta bancaria 60 giorni D.F.",
                    "rimessaDiretta": "Rimessa diretta a ritiro merce"
                  }
            },
            territorioInteresse: {
                name: 'Territorio di Interesse',
                values: {
                    "italia": "Tutta Italia",
                    "nord": "Nord",
                    "nordovest": "Nord Ovest",
                    "nordest": "Nord Est",
                    "centro": "Centro",
                    "centronord": "Centro Nord",
                    "centrosud": "Centro Sud",
                    "sud": "Sud",
                    "sudovest": "Sud Ovest",
                    "sudest": "Sud Est",
                    "sicilia": "Sicilia",
                    "sardegna": "Sardegna"
                }
            },
            provenienzaProdotto: {
                name: 'Provenienza del Prodotto',
                values: {
                    "selezioneRaccoltaDifferenziata": "Selezione della raccolta differenziata"
                }
            },
            dataDisponibilitaMateriale: {
                name: 'Data Disponibilità Materiale'
            },
            tipologiaProdotto: {
                name: 'Tipologia di Prodotto',
                values: {
                    "postconsumo": "Post Consumo",
                    "industriale": "Industriale"
                }
            },
            statoFisico: {
                name: 'Stato del Prodotto',
                values: {
                    "opachiColorati": "Opachi Colorati",
                    "coloriMisti": "Colori Misti",
                    "trasparentiAzzurrati": "Trasparenti Azzurati",
                    "trasparentiIncolore": "Trasparenti incolore"
                }
            },
            imballaggio: {
                name: 'Imballaggio',
                values: {
                    "a10": "Sino a 10 ton",
                    "da10a12": "Da 10 ton a 12 ton",
                    "da12a14": "Da 12 ton a 14 ton",
                    "da14a16": "da 14 ton a 16 ton",
                    "da16a18": "da 16 ton a 18 ton",
                    "da18a20": "da 18 ton a 20 ton",
                    "da22a24": "da 22 ton a 24 ton",
                    "da24a26": "da 24 ton a 26 ton",
                    "da26": "oltre 26 ton"
                }
            },
            qualitaMateriale: {
                name: 'Qualità Materiale',
                values: {
                    "conforme": "Conforme alla Specifica",
                    "nonconforme": "Non conforme alla Specifica",
                    "ottima": "Ottima",
                    "buona": "Buona",
                    "sufficiente": "Sufficiente",
                    "scarsa": "Scarsa",
                    "pessima": "Pessima"
                }
            }
        }
    },
    product: {
        product: 'Prodotto',
    },
    selection_site: {
        selection_sites: 'Centri di Selezione',
        selection_site: 'Centro di Selezione',
        address: 'Indirizzo',
        phone: 'Telefono',
        fax: 'FAX'
    },
    subscriber: {
        subscribers: 'Accreditati'
    },
    profile: {
        profile: 'Profilo',
        change_password: 'Cambia Password',
        logout: 'Logout'
    },
    home: {
        welcome: 'Benvenuti su Aste Corepla',
        login: 'Accedi al portale'
    },
    notifications: {
        auction_closed: 'Asta chiusa!',
        new_auction_available: 'Nuova asta disponibile',
        lot_outbid: 'Una tua offerta è stata superata',
        auction_redistributing_1: 'Asta in redistribuzione - fase 1',
        auction_redistributing_2: 'Asta in redistribuzione - fase 2'
    },
    common: {
        compact_view: 'Vista compatta',
        full_view: 'Vista estesa',
        filters_all_lots: 'Tutti i lotti',
        filters_only_bookmarked_lots: 'Solo preferiti',
        quantity: 'Quantità',
        hide: 'Nascondi',
        close: 'Chiudi',
        relaunch: 'Rilancia',
        relaunch_same_group: '(vs gruppo)',
        offer: 'Fai un\'offerta',
        hours: 'ore',
        minutes: 'minuti',
        seconds: 'secondi',
        days: 'giorni',
        company: 'Azienda',
        group: 'Gruppo',
        price: 'Prezzo',
        date: 'Data',
        refresh: 'Ricarica'
    },
    errors: {
        occurred: 'Si è verificato un errore',
        closeModal: 'Chiudi',
        forceRefresh: 'Ricarica la pagina',
        logout: 'Logout'
    },
    version: {
        new_available: 'Nuova versione disponibile',
        message: 'È disponibile una nuova versione dell\'applicazione. Aggiornare ora?',
        update: 'Aggiorna'
    }
}